import { SunlightScoreBreakdown } from '@/services/score/sunlight';

interface SunlightRecommendationProps {
	scoreData: SunlightScoreBreakdown;
}

export const SunlightRecommendation = ({ scoreData }: SunlightRecommendationProps) => {
	const issues: string[] = [];

	// Check each component and identify weaknesses
	if (scoreData.winterScore / 30 < 0.4) {
		issues.push('improve winter sunlight (most critical)');
	}
	if (scoreData.summerScore / 25 < 0.5) {
		issues.push('optimize summer exposure');
	}
	if (scoreData.springFallScore / 25 < 0.5) {
		issues.push('enhance spring/fall daylight');
	}
	if (scoreData.consistencyScore / 10 < 0.5) {
		issues.push('increase year-round consistency');
	}
	if (scoreData.qualityScore / 10 < 0.5) {
		issues.push('extend daylight duration');
	}

	const score = scoreData.totalScore;

	if (score >= 7.0) {
		return <>Excellent daylight exposure throughout the year with good consistency and duration.</>;
	} else if (score >= 5.0) {
		if (issues.length > 0) {
			return <>Good daylight levels. To improve: {issues.slice(0, 2).join(', ')}.</>;
		}
		return <>Good daylight levels with balanced seasonal exposure.</>;
	} else if (score >= 3.0) {
		if (issues.length > 0) {
			return <>Moderate daylight. Focus on: {issues.slice(0, 2).join(', ')}.</>;
		}
		return <>Moderate daylight. Consider increasing window area or adjusting orientation.</>;
	} else {
		if (issues.length > 0) {
			return <>Insufficient daylight. Priority: {issues.slice(0, 3).join(', ')}.</>;
		}
		return <>Insufficient daylight. Significant improvements needed in window size, placement, or orientation.</>;
	}
};
